<template>
  <button :type="nativeType" @click="handleClick" class="my-button-box" :class="{'my-button-box-disabled':disabled,'my-button-box':!disabled}">
    <slot></slot>
  </button>
</template>
<script>
// <Button1></Button1>
export default {
  name: 'Button6',
  props: {
    nativeType: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  methods: {
    handleClick (evt) {
      if (this.disabled) {
        return
      }
      this.$emit('click', evt)
    }
  },
  mounted () {

  },
  destroyed () {

  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
//
.my-button-box{
  width: 100%;
  height: 40px;
  line-height: 40px;
  border: none;
  background: #0286df;
  border: 1px solid #0286df;
  // padding: 0 21px;
  // border-radius: 4px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  &:hover{
    background: #409ee9;
    border: 1px solid #409ee9;
  }
}
.my-button-box-disabled{
  background:rgba(245,247,250,1);
  border:1px solid rgba(228,231,237,1);
  font-size:14px;
  font-weight:400;
  color:rgba(192,196,204,1);
  cursor:not-allowed;
  &:hover{
       background:rgba(245,247,250,1);
        border:1px solid rgba(228,231,237,1);
    }
}
</style>
